<template>
	<ui-modal name="report-download-modal" icon="fal fa-file-alt" iconCircle closeOnOverlay>
		<section class="modal-content-line">
			<div class="header">
				O <strong>{{ data.subtitle }}</strong> está pronto. As opções de download
				disponíveis estão listadas abaixo...
			</div>
			<div class="input-label">Formato CSV:</div>
			<section class="button-group">
				<ui-code :copy="copy.csv">{{ data.reportResponse.csv }}</ui-code>
				<button class="button link" @click="copyURI('copy.csv')" type="button">
					Copiar
				</button>
				<button
					class="button"
					@click="downloadReport(data.reportResponse.csv)"
					type="button"
				>
					<i class="fal fa-download"></i>
				</button>
			</section>
			<div class="input-label" v-if="moreDownloadFormats && download.xlsx != ''">
				Formato XLSX:
			</div>
			<section class="button-group" v-if="moreDownloadFormats && download.xlsx != ''">
				<ui-code :copy="copy.xlsx">
					{{ download.xlsx }}
				</ui-code>
				<button class="button link" @click="copyURI('copy.xlsx')" type="button">
					Copiar
				</button>
				<button class="button" @click="downloadReport(download.xlsx)" type="button">
					<i class="fal fa-download"></i>
				</button>
			</section>
			<div class="input-label mb-12" v-if="moreDownloadFormats && download.xlsx == ''">
				Mais formatos de download:
			</div>
			<section class="more-downloads-group">
				<div
					class="link-primary"
					@click="showMoreDownloadFormats"
					v-if="!moreDownloadFormats"
				>
					Ver mais formatos de download...
				</div>
				<ui-button
					:loading="loader.generateReport.xlsx"
					design="sm line-success-alt"
					v-if="moreDownloadFormats && download.xlsx == ''"
					@click="getReportConversion('xlsx')"
				>
					Gerar Relatório XLSX
				</ui-button>
			</section>
		</section>
	</ui-modal>
</template>

<script>
	import { uiModal } from '@/components/ui/modal'

	import { uiCode } from '@/components/ui'
	import { uiButton } from '@/components/ui/buttons'

	import { reports } from '@/services/axios'

	const defaultLoader = () => ({
		generateReport: { xlsx: false },
	})

	export default {
		name: 'report-download-modal',

		components: { uiModal, uiCode, uiButton },

		data() {
			return {
				copy: { csv: false, xlsx: false },
				moreDownloadFormats: false,

				data: {
					subtitle: '',
					reportResponse: { reportName: '', csv: '', xlsx: '' },
				},
				download: { xlsx: '' },

				loader: { ...defaultLoader() },
			}
		},

		methods: {
			// Request the report conversion in the API
			async getReportConversion(format) {
				try {
					this.loader.generateReport[format] = true

					const response = await reports.convert({
						url: this.data.reportResponse.csv,
						reportName: this.data.reportResponse.reportName,
						fromType: 'csv',
						toType: format,
					})

					// Has error
					if (response.data.status == 'error' || response.data.msg) {
						this.loader.generateReport[format] = false
						this.$toastr.e(
							`Ocorreu um erro ao solicitar a conversão do relatório para o formato ${format}, tente novamente!`,
						)
						return
					}

					// Not done yet, try again in 5 seconds
					if (response.data.status == 'success' && !response.data.urls[format]) {
						setTimeout(async () => {
							await this.getReportSuccess(response, format)
						}, 5000)

						return
					}

					this.download[format] = response.data.urls[format]
					this.loader.generateReport[format] = false
				} catch {
					this.loader.generateReport[format] = false
					this.$toastr.e(
						`Ocorreu um erro ao solicitar a conversão do relatório para o formato ${format}, tente novamente!`,
					)
				}
			},

			// Search the report in the API
			async getReportSuccess(reportConversionResponse, format) {
				try {
					this.loader.generateReport[format] = true

					const response = await reports.search(reportConversionResponse.data.jobId, {
						reportName: reportConversionResponse.data.reportName,
						fromType: 'csv',
						toType: format,
					})

					// Has error
					if (response.data.status == 'error' || response.data.msg) {
						this.loader.generateReport[format] = false
						this.$toastr.e(
							`Ocorreu um erro ao solicitar o download do relatório com o formato ${format}, tente novamente!`,
						)
						return
					}

					// Not done yet, try again in 5 seconds
					if (response.data.status == 'success' && !response.data.urls[format]) {
						setTimeout(async () => {
							await this.getReportSuccess(response, format)
						}, 5000)

						return
					}

					this.download[format] = response.data.urls[format]
					this.loader.generateReport[format] = false
				} catch {
					this.loader.generateReport[format] = false
					this.$toastr.e(
						`Ocorreu um erro ao solicitar o download do relatório com o formato ${format}, tente novamente!`,
					)
				}
			},

			// Enable more download formats to be generate
			showMoreDownloadFormats() {
				this.moreDownloadFormats = true
			},

			// Open download link in browser
			downloadReport(URI) {
				window.open(URI)
			},

			// Copy download link to clipboard
			copyURI(file) {
				switch (file) {
					case 'copy.csv':
						this.copy.csv = true

						setTimeout(() => {
							this.copy.csv = false
						}, 3000)

						break
					case 'copy.xlsx':
						this.copy.xlsx = true

						setTimeout(() => {
							this.copy.xlsx = false
						}, 3000)

						break
					default:
						break
				}
			},
		},

		watch: {
			data: {
				handler(newVal, oldVal) {
					if (newVal.reportResponse.xlsx) {
						this.download.xlsx = newVal.reportResponse.xlsx
						this.moreDownloadFormats = true
					} else this.download.xlsx = ''

					if (!this.download.xlsx) this.moreDownloadFormats = false
				},
				deep: true,
			},
		},

		created() {
			// Receive the previous data
			this.$root.$on('athena-reports-download-report', (data) => {
				this.data = data
			})
		},

		beforeDestroy() {
			this.$root.$off('athena-reports-download-report')
		},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
